module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/core-js/library/modules/$.fails.js
// module id = 500
// module chunks = 2